module.exports = __webpack_public_path__ + "images/if6_schnellrechner_scenario_2_web.svg?ab64e0691d3d3855f7791d107fa60cc3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/if6_schnellrechner_scenario_2_web.svg
// module id = cBdk
// module chunks = 0